module.exports = __webpack_public_path__ + "8102c48.woff";